import React, { Component } from 'react';
import { Pagination } from 'antd';
import axios from 'axios';
import config from '../dummy_data/configuration.json';
import ProductList from '../components/ProductList'
import Navigation from '../components/Navigation'
import Breadcrumb from '../components/Breadcrumb'
// import Footer from '../components/Footer'
import SimpleFooter from '../components/SimpleFooter'
import {BreadcrumbItems} from '../dummy_data/localizationItems.json'

class ProductCenter extends Component {

	constructor () {
		super()
		this.state = {
			footerItem: {},
			productLinesItems: [],
			productItems: [],
			presentItems: [],
			showMobileMenu: false
		}
	}

	componentWillMount() {
		// console.log(this.props.match.params);
		this._getProductLines();

		if(this.props.match.params.productType){
  			this._refreshData(this.props.match.params.productType);
  		}

  		this._getFooter();
	}

	componentDidMount() {
		window.scrollTo(0,0)
	}

	componentWillReceiveProps(nextProps) {
		if(nextProps.match.params.productType){
  			this._refreshData(nextProps.match.params.productType);
  		}
	}

	handleShowHideMobileMenu = () =>{
		this.setState({
	      	showMobileMenu: !this.state.showMobileMenu
	    });
	}

	handleScreenClick = (event) => {
		if(event.target.tagName !== "A" && event.target.className !== "fa fa-bars" && event.target.className !== "navigation-folded" && event.target.offsetParent.className.indexOf("mobile") < 0){
			this.setState({
		      	showMobileMenu: false
		    });
		}
	}

	handlePageChange = (page, pageSize) => {
		console.log(`page: ${page}, page size: ${pageSize}`);
		this.setState({
            	presentItems: this.state.productItems.slice((page - 1) * 12, page * 12)
            });
	}

	_refreshData = (productType) => {
		axios({
	        method: 'GET',
	        url: `${config.productsAction}?productType=${productType}`,
	        responseType:'json',
	        headers: {'requestType': 'FN'}
	    }).then((res)=>{
            // console.log(res);
            this.setState({
            	productItems: res.data,
            	presentItems: res.data.slice(0, 12)
            });
        }).catch((err)=>{
            console.log(err.status);
        })
	}

	_getProductLines = () => {
		axios({
	        method: 'GET',
	        url: config.productLinesAction,
	        responseType:'json',
	        headers: {'requestType': 'FN'}
	    }).then((res)=>{
            this.setState({
            	productLinesItems: res.data
            });
        }).catch((err)=>{
            console.log(err.status);
        })
	}

	_getFooter = () => {
		axios({
	        method: 'GET',
	        url: config.footerAction,
	        responseType:'json',
	        headers: {'requestType': 'FN'}
	    }).then((res)=>{
            // console.log(res);
            this.setState({
            	footerItem: res.data
            });
        }).catch((err)=>{
            console.log(err.status);
        })
	}

	_mapProdType = (type) => {
		// if(type === 'EMERSON'){
		// 	return '防爆灯具及电器产品'
		// }
		// else if(type === 'UNISTRUT'){
		// 	return '电缆托架产品'
		// }
		// else if(type === 'LEONI'){
		// 	return '仪表及动力电缆'
		// }
		// else if(type === 'HEADHUNTER'){
		// 	return '生活污水处理装置'
		// }
		// else if(type === 'LiquidControl'){
		// 	return '流量计及罐区自动化产品'
		// }
		// else if(type === 'Autocontrol'){
		// 	return '自动取样设备'
		// }

		let target = this.state.productLinesItems.find(pl => pl.ID == type);
		if(target){
			return target.Name;
		}

		return '';
	}

	render() {
		const location = [];
		location.push({
			name: localStorage.getItem("isEnglish") === "true"? BreadcrumbItems.find(i => i.fieldName === "Products").eName : BreadcrumbItems.find(i => i.fieldName === "Products").name,
			url: "/products/All"
		});

		if(this.props.match.params.productType !== "All"){
			location.push({
				name: this._mapProdType( this.props.match.params.productType ),
				url: this.props.match.url
			});
		}		

		// console.log(this.props.match);
		return(
			<div onClick={this.handleScreenClick}>
				<Navigation showMobileMenu={ this.state.showMobileMenu } handleShowHideMobileMenu={ this.handleShowHideMobileMenu}/>
				<div className="banner"><img src={require("../img/news.jpg")} alt="" /></div>
				<div className="content-container">
					<Breadcrumb location={location} />
					<div className="block-content product-list">
			            <div className="product-list-left">
			                <h3>
			                    <p><b>产品分类</b><span>PRODUCT CATEGORY</span></p>
			                </h3>
			                <ul className="product-list-category">
			                    {/*<li><a href="#/products/EMERSON">防爆灯具及电器产品</a></li>
			                    <li><a href="#/products/UNISTRUT">电缆托架产品</a></li>
			                    <li><a href="#/products/LEONI">仪表及动力电缆</a></li>
			                    <li><a href="#/products/HEADHUNTER">生活污水处理装置</a></li>
			                    <li><a href="#/products/LiquidControl">流量计及罐区自动化产品</a></li>
			                    <li><a href="#/products/Autocontrol">自动取样设备</a></li>*/}
			                    {
										this.state.productLinesItems.map((item, i) => {
			                              return(<li key={i}><a href={`#/products/${item.ID}`}>{item.Name}</a></li>);
			                        })
								}
			                </ul>
			                <div className="product-list-contact">
			                    <img src={require("../img/phImg.png")} alt="" />
			                    <div>
			                        <span>咨询热线</span>
			                        <p>{this.state.footerItem.PhoneNumber1}</p>
			                    </div>
			                </div>
			            </div>
			            <div className="product-list-right">
			                <ProductList items={this.state.presentItems} />
			                <Pagination className="product-list-pagination" defaultPageSize={12} defaultCurrent={1} total={this.state.productItems.length} onChange={this.handlePageChange} />
			            </div>
			        </div>
					
					
				</div>
				{/*<Footer item={this.state.footerItem} />*/}
				<SimpleFooter item={this.state.footerItem} />
			</div>
		)
	}
}

export default ProductCenter;


// WEBPACK FOOTER //
// ./src/pages/ProductCenter.js